import { useRoutes } from "react-router";
import MispLayout from "../MispLayout";
import Loadable from '../../posp/ui-component/Loadable';

import { lazy } from "react";
import Payouts from "../pages/payouts";
const Dashboard = Loadable(lazy(() => import('../pages/dashboard/Dashboard')));
const Bookings = Loadable(lazy(() => import('../pages/bookings')))
const PersonalDetails = Loadable(lazy(() => import('../pages/personaldetails/PersonalDetails')));
const Main = Loadable(lazy(() => import('../../posp/pages/Main')));
const MotorPolicy = Loadable(lazy(() => import('../pages/offlinePolicy/MotorPolicy')));
const HealthPolicy = Loadable(lazy(() => import('../pages/offlinePolicy/HealthPolicy')));
const LoanPolicy = Loadable(lazy(() => import('../pages/offlinePolicy/LoanPolicy')));
const LifeOfflineForm = Loadable(lazy(() => import('../pages/offlinePolicy/LifePolicy')))


export default function MispRoutes() {
    return useRoutes([
        {
            path: '/',
            element: <MispLayout />,
            children: [
                {
                    path: '/home',
                    element: <Main />
                },
                {
                    path: '/dashboard',
                    element: <Dashboard />
                },
                {
                    path: '/personaldetails',
                    element: <PersonalDetails />
                },
                {
                    path: '/bookings',
                    element: <Bookings />
                },
                {
                    path: '/health',
                    element: <HealthPolicy />
                },
                {
                    path: '/motor',
                    element: <MotorPolicy />
                },
                {
                    path: '/life',
                    element: <LifeOfflineForm />
                },
                {
                    path: '/loan',
                    element: <LoanPolicy />
                },
                {
                    path: '/payouts',
                    element: <Payouts />
                },
                // {
                //     path: '/travel',
                //     element: <TravelPolicy />
                // },
                // {
                //     path: '/policyclaims',
                //     element: <PolicyClaim />
                // },
                // {
                //     path: '/invoice',
                //     element: <Invoice />
                // },
                // {
                //     path: '/settings',
                //     element: <Settings />
                // },
                // {
                //     path: '/helpline',
                //     element: <Support />
                // },

            ]
        }
    ]);
}